import { useRef, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { Whisper, Popover } from "rsuite";

import IndeterminateCheckbox from "../AppTable/IndeterminateCheckbox";
import TableActionsMenu from "../CRM/TableActionsMenu";

const AppTableListHeader = ({
  view,
  isSelection,
  onSelectAll,
  onDeselectAll,
  setExportDrawer,
  loadTableInformation,
  toggleUpdateRecordsModal,
  toggleBulkApplyTags,
  toggleTemplateCSVModal,
  deleteSelectedRecords,
  toggleMergeDrawer,
  handleDuplicateRecord,
  selectedRecordsLength,
  selectedRecords,
  selectable,
}) => {
  const actionsRef = useRef();
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const onCheckboxChecked = () => {
    if (checkboxChecked) {
      onDeselectAll();
    } else {
      onSelectAll();
    }

    setCheckboxChecked((prev) => !prev);
  };

  return (
    <>
      <Row
        className="d-flex justify-content-between align-items-center mb-2 p-0"
        style={{ height: 30 }}
      >
        <Col xs={1}></Col>
        {selectable && (
          <Col xs={1} style={{ marginLeft: -3 }}>
            <IndeterminateCheckbox
              onChange={onCheckboxChecked}
              checked={checkboxChecked}
              disabled={!selectable}
            />
          </Col>
        )}

        <Col>
          <div
            style={{ fontSize: "12px" }}
            className="font-weight-500 text-dark"
          >
            Record Name
          </div>
        </Col>
        <Col xs="auto" className="m-0 p-0 pr-3">
          {isSelection && (
            <Whisper
              placement="autoVerticalEnd"
              trigger="click"
              ref={actionsRef}
              speaker={
                <Popover
                  className="sidebar-popover"
                  full
                  onClick={() => actionsRef.current.close()}
                >
                  <TableActionsMenu
                    moduleAPIName={view?.ModuleAPIName}
                    isSelection={isSelection}
                    selectedRecords={selectedRecords}
                    setExportDrawer={setExportDrawer}
                    load={loadTableInformation}
                    toggleUpdate={toggleUpdateRecordsModal}
                    toggleUpdateTags={toggleBulkApplyTags}
                    toggleTemplateCSV={toggleTemplateCSVModal}
                    deleteSelectedRecords={deleteSelectedRecords}
                    toggleMerge={toggleMergeDrawer}
                    onDuplicate={handleDuplicateRecord}
                  />
                </Popover>
              }
            >
              <Button
                size="sm"
                color="primary"
                className="d-flex justify-content-center align-items-center btn-icon-only pl-1"
                style={{ width: "100%", height: "24px" }}
              >
                <span style={{ fontSize: "12px" }}>
                  {selectedRecordsLength}&nbsp;Selected
                </span>
                <i
                  style={{ fontSize: "18px" }}
                  className="mdi mdi-chevron-down m-0 ml-1 mb-1"
                ></i>
              </Button>
            </Whisper>
          )}
        </Col>
      </Row>
    </>
  );
};

export default AppTableListHeader;
